import { apiClient } from './baseApi';

export const appRolesService = {
  async listRoles() {
    const response = await apiClient.get('/admin/roles');
    return response.data?.data ?? [];
  },

  async listAssignedUsers() {
    const response = await apiClient.get('/admin/user-roles');
    return response.data?.data ?? [];
  },

  async assignUserRole(email, roleCode) {
    const response = await apiClient.post('/admin/user-roles', { email, roleCode });
    return response.data?.data;
  },

  async revokeUserRole(id) {
    const response = await apiClient.delete(`/admin/user-roles/${id}`);
    return response.data?.data;
  },
};
